const listeners = new Set();

export const ANALYTICS_CACHE_PREFIXES = [
  '/api/analytics/overview',
  '/api/analytics/posts-summary',
  '/api/analytics/insights',
];

export function subscribeAnalyticsRefresh(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyAnalyticsRefresh(scope) {
  if (!scope) return;
  for (const listener of listeners) listener(scope);
}
